<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lglz" alt style="line-height:1.5;">
        <span style="line-height:1.5;">&nbsp;</span>
      </p>
      <p></p>
      <p>
        <b>
          <span style="font-family:Arial;font-size:18px;">
            Continues casting and
            rolling production line for Aluminum Rods
          </span>
        </b>
      </p>
      <p>
        <span style="font-family:&quot;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-family:Arial;">1</span>
        <span style="font-family:Arial;color:black;">.</span>
        <span style="font-family:Arial;">
          Aluminum pole continue casting
          direct rolling production line is used for producing high strength conductive
          alloy pole like aluminum pole, al-mg alloy and al-mg-si alloy with diameter 9.5mm and 12mm etc, it could be match other similar products
          around the world.
        </span>
      </p>
      <p>
        <span style="font-family:&quot;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-family:Arial;">2</span>
        <span style="font-family:Arial;color:black;">.</span>
        <span style="font-family:Arial;">
          It used circular fast
          energy-saving aluminum melting furnace with permanent magnet stirrer, in order
          to equipping, uniform and refining of aluminum alloy.
        </span>
      </p>
      <p>
        <span style="font-family:宋体;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-family:Arial;color:black;">3.</span>
        <span style="font-family:Arial;">
          It used the way of casting on
          flat, when casting, the liquid of aluminum alloy flew smoothly from middle pot to
          crystallizing wheel, to avoid turbulence.
        </span>
      </p>
      <p>
        <span style="font-family:宋体;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-family:Arial;color:black;">4.</span>
        <span style="font-family:Arial;">
          Tandem mill system used the
          rolling way of two-roller and three-roller combined, it was helped for roll
          compacting and deformation of ingot casting. This system could insure the ingot
          blank stress uniform.
        </span>
      </p>
      <p>
        <span style="font-family:&quot;color:black;"></span>
        <span style="font-family:宋体;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-family:Arial;color:black;">5.</span>
        <span style="font-family:Arial;">
          This production line
          transmission used siemens digital dc timing device. The PLC could command and
          coordination the whole system accurately and reliably in the control part, main
          and auxiliaries gang controlled all line, high control accuracy, low failure,
          easy maintenance, system is stable and reliable. Operating with human-machine
          interface, which easy to send instruction, check running status of equipment,
          set, modify, display the device parameters, and have the function of fault
          diagnosis.
        </span>
      </p>
      <p>
        <span style="font-family:&quot;color:black;"></span>
        <span style="font-size:10.0pt;font-family:&quot;color:black;"></span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lglz: require("../../../assets/img/common/lglz.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/lglz.vue